import React, { Component } from 'react'
import InputRow from './InputRow'
import { handleAlphabetCheck, handleNumberCheck } from '../constants'
import PropTypes from 'prop-types'
export default class Parent extends Component {
  render () {
    return (

      <div>
        <div>
          <InputRow
            name="select"
            data={this.props.relationshipData}
            required={this.props.deceased ? '' : '*'}
            errMsg={this.props.errRelation}
            value={this.props.relationship}
            onChange={(e) => this.props.relationshipUpdate(e)}
            rowName= "Relationship with You"
            disabled={this.props.disabled}
            hover="Tell us how the person is related to you. أخبرنا كيف يرتبط الشخص بك."
          />
          <InputRow
            name="select"
            data={this.props.prefixData}
            value={this.props.selectedPrefix}
            onChange={this.props.onChangePrefix}
            rowName="Prefix"
            required={this.props.deceased ? '' : '*'}
            errMsg={this.props.errPrefix}
            disabled={this.props.disableAll}
          />
          <InputRow
            name="text"
            rowName="Given Name"
            required={this.props.deceased ? '' : '*'}
            errMsg={this.props.errFName}
            value={this.props.fName}
            onChange={(e) => {
              if (handleAlphabetCheck(e) === 1 || e === '') { this.props.onChangeFName(e) } else { alert('Please Enter Alphabets only!') }
            }}
            disabled={this.props.disableAll}
            //hover="Enter the name of one of the following: your mother, your father or your legal guardian. أدخل اسم أحد الإجراءات التالية: أمك أو والدك أو الوصي القانوني. "
          />
          <InputRow
            name="text"
            rowName="Middle Name"
            required={this.props.deceased ? '' : '*'}
            errMsg={this.props.errMName}
            value={this.props.mName}
            onChange={(e) => {
              if (handleAlphabetCheck(e) === 1 || e === '') { this.props.onChangeMName(e) } else { alert('Please Enter Alphabets only!') }
            }}
            disabled={this.props.disableAll}
          />
          <InputRow
            name="text"
            rowName="Family Name"
            required={this.props.deceased ? '' : '*'}
            errMsg={this.props.errLName}
            value={this.props.lName}
            onChange={(e) => {
              if (handleAlphabetCheck(e) === 1 || e === '') { this.props.onChangeLName(e) } else { alert('Please Enter Alphabets only!') }
            }}
            disabled={this.props.disableAll}
          />
          <InputRow
            name="text"
            rowName="Profession"
            required={this.props.deceased ? '' : '*'}
            errMsg={this.props.errProfession}
            value={this.props.profession}
            onChange={(e) => {
              this.props.onChangeProfession(e)
            }}
            disabled={this.props.disableAll}
           // hover="Insert the current job held by your parent. (For data collection and analysis purposes only. This will not effect your application.)"
            hover={this.props.guardian  ? 'Insert the current job held by your guardian. (For data collection and analysis purposes only. This will not effect your application.)' : 'Insert the current job held by your parent. (For data collection and analysis purposes only. This will not effect your application.)'}
         />
         
          <InputRow
            name="text"
            rowName="Mobile Number"
            required={this.props.deceased ? '' : '*'}
            errMsg={this.props.errMobile}
            value={this.props.mobileNumber}
            onChange={(e) => {
              if (handleNumberCheck(e) === 0) { this.props.onChangeNumber(e) } else { alert('Enter Numbers only!') }
            }}
            disabled={this.props.disableAll}
            hover={this.props.guardian  ? 'Insert the contact number of your guardian. رقم الاتصال لوالدك.' : 'Insert the contact number of your parent. رقم الاتصال لوالدك.'}
           // hover="Insert the contact number of your parent. رقم الاتصال لوالدك."
          />
        <InputRow
            name="email"
            rowName="E-mail Address"
            required={this.props.guardian || this.props.relationship == 4 ? '*' : ''} // 4 is the father Id
            value={this.props.email}
            onChange={(val) => this.props.onChangeEmail(val)}
            errMsg={this.props.errEmail}
            //disabled={this.props.disableAll}
            hover={this.props.guardian  ? 'Insert the email address of your guardian . عنوان البريد الإلكتروني لوالديك.' : 'Insert the email address of your parent . عنوان البريد الإلكتروني لوالديك.'}
            //hover="Insert the email address of your parent . عنوان البريد الإلكتروني لوالديك."
          />
        
        </div>
      </div>

    )
  }
}
Parent.propTypes = {
  relationshipData: PropTypes.array.isRequired,
  relationship: PropTypes.number.isRequired,
  relationshipUpdate: PropTypes.func,
  disabled: PropTypes.bool,
  disableAll: PropTypes.bool,
  prefixData: PropTypes.array.isRequired,
  selectedPrefix: PropTypes.number.isRequired,
  onChangeAddress: PropTypes.func.isRequired,
  onChangeCompany: PropTypes.func.isRequired,
  onChangeCompanyAddress: PropTypes.func.isRequired,
  onChangeEmail: PropTypes.func.isRequired,
  onChangeFName: PropTypes.func.isRequired,
  onChangeLName: PropTypes.func.isRequired,
  onChangeMName: PropTypes.func.isRequired,
  onChangeNumber: PropTypes.func.isRequired,
  onChangePrefix: PropTypes.func.isRequired,
  onChangeProfession: PropTypes.func.isRequired,
  fName: PropTypes.string.isRequired,
  mName: PropTypes.string.isRequired,
  lName: PropTypes.string.isRequired,
  profession: PropTypes.string.isRequired,
  company: PropTypes.string.isRequired,
  companyAddress: PropTypes.string.isRequired,
  mobileNumber: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  address: PropTypes.string.isRequired,
  errEmail: PropTypes.string,
  errRelation: PropTypes.string,
  errPrefix: PropTypes.string,
  errFName: PropTypes.string,
  errMName: PropTypes.string,
  errLName: PropTypes.string,
  errProfession: PropTypes.string,
  errMobile: PropTypes.string,
  deceased: PropTypes.bool,
  deceasedOption: PropTypes.bool,
  deceasedChange: PropTypes.func,
  emailRequired: PropTypes.bool,
  guardian: PropTypes.bool
}
